import { useEffect, useRef } from 'react';
import type { LogEntry } from '../../types/api';

const LEVEL_CLASS: Record<string, string> = {
  INFO:    'log-info',
  WARNING: 'log-warn',
  WARN:    'log-warn',
  ERROR:   'log-err',
  DEBUG:   '',
};

interface LogStreamProps {
  logs: LogEntry[];
  maxRows?: number;
}

export function LogStream({ logs, maxRows = 50 }: LogStreamProps) {
  const bottomRef = useRef<HTMLDivElement>(null);
  const visible = logs.slice(-maxRows);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [logs.length]);

  if (visible.length === 0) {
    return (
      <div className="log-stream">
        <span style={{ fontStyle: 'italic' }}>No log entries yet…</span>
      </div>
    );
  }

  return (
    <div className="log-stream">
      {visible.map((entry, i) => (
        <div key={i}>
          <span className="log-ts">{new Date(entry.timestamp).toLocaleTimeString()}</span>
          <span className={LEVEL_CLASS[entry.level] ?? ''} style={{ marginRight: 8, fontWeight: 600 }}>
            [{entry.level}]
          </span>
          <span>{entry.message}</span>
        </div>
      ))}
      <div ref={bottomRef} />
    </div>
  );
}
